import { useCallback, useMemo } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { dateChatWasClosedSelector, messagesSelector, setChatOpen } from "@/domains/chat/slice";
import ChatOpenButton from "@/domains/chat/components/chat/controls/ChatOpenButton";

export default function ChatOpenButtonContainer() {
  const dispatch = useAppDispatch();
  const messages = useAppSelector(messagesSelector);
  const dateChatWasClosed = useAppSelector(dateChatWasClosedSelector);
  const hasIndicator = useMemo(() => {
    if (!messages.length) return false;

    const lastMessage = messages[messages.length - 1];
    const numDateLastMessage = Number(lastMessage.date);
    const numDateChatWasClosed = Number(dateChatWasClosed);
    return numDateLastMessage > numDateChatWasClosed;
  }, [dateChatWasClosed, messages]);

  const onClickHandler = useCallback(() => dispatch(setChatOpen(true)), [dispatch]);

  return <ChatOpenButton onClick={onClickHandler} hasIndicator={hasIndicator} />;
}
